
import {
  email,
  required,
  minLength
} from "vuelidate/lib/validators";
import {
  UserMixin,
  UserAuthMixin
} from '~/node_modules/sitis-nuxt/lib/mixins';

export default {
  name: "PopUpAuthorization",

  data: function () {
    return {
      form: {
        username: "",
        password: "",
      }
    }
  },

  props: {
    isComponent: {
      type: Boolean,
      default: false
    }
  },

  mixins: [
    UserMixin,
    UserAuthMixin
  ],

  validations: function () {
    const form = {
      username: {
        required,
      },
      password: {
        required
      },
    };

    return {
      form,
    };
  },

  computed: {
    isOpen: function () {
      return this.$store.state?.authRegistration?.isOpenAuth || this.isComponent || false
    },

    errorUsername: function () {
      const error = this.$v?.form?.username;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }
      if (!error.required) {
        return "Обязательно к заполнению"
      }

      return null
    },
    errorPassword: function () {
      const error = this.$v?.form?.password;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }
      if (!error.required) {
        return "Обязательно к заполнению"
      }

      return null
    },
  },

  methods: {
    resetForm: function () {
      this.form = {
        name: "",
        phone: "",
        message: "",
      };
      this.$v.$reset();
    },
    submitForm: async function () {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return null;
      }

      this.$store.commit("loading/setLoading", {name: 'popUpLoading', value: true});
      const res = await this.$api.agent.transport.post(`/users/login`, this.form, {
        baseURL: process.env.transportationApiUrl
      }).then((res) => {
        return res.data
      }).catch((err) => {
        return {error: err.response || true}
      });
      if (res?.error) {
        this.$store.commit("loading/setLoading", {name: 'popUpLoading', value: false});
        let messages = [];
        (res?.error?.data || []).map((t) => {
          messages.push(t?.message)
        });
        messages = messages.join(";<br/>") || "Ошибка сервера";
        this.$toast.error(messages);
        return
      }

      const {token} = res;
      this.setToken({
        authToken: token,
      });
      const cookiesOpt = this.$getCookiesOpt({
        expires: new Date(new Date().setFullYear(new Date().getFullYear() + 5))
      });
      console.log('cookiesOpt :', cookiesOpt);
      this.$cookies.set('authToken', token, cookiesOpt);
      this.setToken({
        authToken: token
      });

      await this.$store.dispatch("authRegistration/getUserTransportation")

      const isUserDriver = await this.$api.agent.transport.get('/transportation/check-user', {
        baseURL: process.env.transportationApiUrl
      }).then((res) => {
        return Boolean(res.data === 'Водители')
      }).catch(() => {
        return false
      });
      if (isUserDriver) {
        window.location.href = process.env.transportationSiteUrl;
        return
      }

      this.$store.commit("loading/setLoading", {name: 'popUpLoading', value: false});
      this.resetForm();
      this.onClose();
      this.$router.push('/distillation')
    },

    onClose: function () {
      this.$store.commit("authRegistration/setOpen", {
        name: "isOpenAuth",
        value: false
      })
    }
  }
}
